<div>
    <a (click)="exitScreen()" *ngIf="lockscreenMode == LOCKSCREEN_MODE.ASK_FOR_PERMISSION" style="cursor: pointer"><i-tabler name="x" style="color: #666; font-size: 32px; position: absolute; right: 10px; top: 10px"></i-tabler></a>
    <div style="display: flex; padding: 20px;">
        <img src="assets/images/logos/clu-dark-logo.svg" alt="logo" style="width: 130px; margin: auto;">
    </div>
    <div style="font-weight: 600;font-size: 28px;margin-bottom: 10px;">Application verouillée</div>
    <div style="font-weight: 600;">Votre session est vérouillée ou une action nécessitant un visa a été déclenchée.</div>
    <div style="font-weight: 600;margin-bottom: 20px;">Veuillez saisir vos accès pour déverrouiller l'écran.</div>
    <div class="d-flex align-items-center justify-content-center p-b-24 m-t-16" *ngIf="!!activeUserAccount">
        <img src="assets/images/profile/ninja-bo.png" class="rounded-circle" height="45px" />
        <div class="m-l-16">
          <h6 class="f-s-14 f-w-600 m-0">{{ activeUserAccount.USERNAME }}</h6>
          <span class="f-s-14 d-block m-b-4">Utilisateur</span>
        </div>
    </div>
    <div class="numpad-container">
        <input type="password" class="numpad-field" readonly="readonly" [value]="!!codepin[0] ? codepin[0] : ''">
        <input type="password" class="numpad-field" readonly="readonly" [value]="!!codepin[1] ? codepin[1] : ''">
        <input type="password" class="numpad-field" readonly="readonly" [value]="!!codepin[2] ? codepin[2] : ''">
        <input type="password" class="numpad-field" readonly="readonly" [value]="!!codepin[3] ? codepin[3] : ''">
        <input type="password" class="numpad-field" readonly="readonly" [value]="!!codepin[4] ? codepin[4] : ''">
        <input type="password" class="numpad-field" readonly="readonly" [value]="!!codepin[5] ? codepin[5] : ''">
    </div>
    <div style="height: 90px;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <mat-spinner diameter="25" *ngIf="loading"></mat-spinner>
        <div class="error-container" *ngIf="!!errorText">{{ errorText }}</div>
    </div>
    <div style="display: flex; flex-direction: column; justify-content: center; gap: 10px">
        <button mat-raised-button (click)="openNumpadDialog()" color="primary" style="height: 50px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <span class="d-flex">
                <i-tabler name="dialpad" style="color: white; font-size: 10px;margin-right: 8px;"></i-tabler> 
                Ouvrir le clavier numérique
            </span>
        </button>
        <button mat-raised-button (click)="openAccountPickerDialog()" *ngIf="usersAccounts.length > 1" style="height: 50px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <span class="d-flex">
                <i-tabler name="users-group" style="font-size: 10px;margin-right: 8px;"></i-tabler>
                Changer de compte
            </span>
        </button>
        <button mat-raised-button (click)="doLogout()" *ngIf="lockscreenMode == LOCKSCREEN_MODE.LOCK_SESSION" style="height: 50px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <span class="d-flex">
                <i-tabler name="logout" style="font-size: 10px;margin-right: 8px;"></i-tabler>
                Se déconnecter
            </span>
        </button>
    </div>
</div>